import { Device } from 'synapse-common-device-service';
import { UpdateRow } from '../types/frontend/update-row';
import { UpdateJobItem } from '../../windows-updates/models/update-job-item';
import Tenant from '../../core/models/Tenant';

export const tenantChameleonFilterFnForUpdate = (
  rowData: UpdateRow,
  selectedTenants: Tenant[],
  tenantDevicesObj: { devices?: Device[]; error?: Error; isLoading: boolean }
): boolean => {
  if (selectedTenants.length === 0) return true;

  const deviceTenants = tenantDevicesObj.devices
    ?.filter(device => {
      return !!rowData.availableForGroups?.find(group => group.id === device.deviceGroupId);
    })
    ?.map(device => device.group?.tenant);

  if (!deviceTenants) return false;

  if (deviceTenants.length === 0) {
    if (selectedTenants.find(tenant => tenant.uuid === 'items-without-tenant')) {
      return true;
    }
    return false;
  }

  if (selectedTenants.find(tenant => deviceTenants.find(deviceTenant => deviceTenant?.id === (tenant as any).uuid))) {
    return true;
  }
  return false;
};

export const tenantChameleonFilterFnForJob = (
  rowData: UpdateJobItem,
  selectedTenants: Tenant[],
  tenantDevices: Device[]
): boolean => {
  if (selectedTenants.length === 0) return true;

  const deviceTenants = tenantDevices
    ?.filter(device => {
      return !!rowData.devicesNames?.find(deviceId => deviceId === device.id);
    })
    ?.map(device => device.group?.tenant);

  if (!deviceTenants) return false;

  if (deviceTenants.length === 0) {
    if (selectedTenants.find(tenant => tenant.uuid === 'items-without-tenant')) {
      return true;
    }
    return false;
  }

  if (selectedTenants.find(tenant => deviceTenants.find(deviceTenant => deviceTenant?.id === (tenant as any).uuid))) {
    return true;
  }
  return false;
};
